/* eslint-disable */
// @ts-nocheck
export function getPlaceholder(options: any[] | null | undefined, creatable: boolean) {
  if (!creatable) {
    return 'Select...';
  }

  if (!options || !options.length) {
    return 'Input values...';
  }

  return 'Select/Input values...';
}
